import { Component } from '@angular/core';

@Component({
  selector: 'app-authority-toast',
  template: `
    <div class="authority-toast">
      <div class="toast-content">
        <span class="toast-icon">⚠️</span>
        <span class="toast-message">{{ message }}</span>
      </div>
    </div>
  `,
  styles: [`
    .authority-toast {
      background: #ffa726;
      color: #fff;
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(255,167,38,0.12);
      padding: 18px 24px 14px 24px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      min-width: 320px;
      font-family: inherit;
    }
    .toast-content {
      display: flex;
      align-items: center;
      width: 100%;
      margin-bottom: 8px;
    }
    .toast-icon {
      font-size: 1.5em;
      margin-left: 10px;
    }
    .toast-message {
      font-weight: 500;
      font-size: 1.08em;
      flex: 1;
      text-align: right;
    }
  `]
})
export class AuthorityToastComponent {
  static message: string = '';
  constructor() {}

  get message() {
    return AuthorityToastComponent.message;
  }
}
